import type { SourceDescriptor } from '../types/source.ts';

/**
 * 管理ダッシュボードで表示するデータソースのフロント側メタ情報。
 * 仕様: knowledge/products/trendscope/specs/data-sources.md §1
 *
 * `implemented=true` のソースのみ管理UIから収集ボタンが押せる。
 * 動的取得（GET /api/sources）は将来の課題。
 */

export const SOURCE_DESCRIPTORS: readonly SourceDescriptor[] = [
  {
    name: 'houjin',
    display_name: '国税庁法人番号API',
    description: '新規設立法人を業種別に集計（供給シグナル）',
    collect_endpoint: '/api/collect/houjin',
    phase: 1,
    implemented: true,
  },
  {
    name: 'news',
    display_name: 'Google News RSS',
    description: '業種別記事件数（メディアシグナル）。本文非保存',
    collect_endpoint: '/api/collect/news',
    phase: 2,
    implemented: true,
  },
  {
    name: 'hatena',
    display_name: 'はてなブックマーク',
    description: '業種別エントリー数とブクマ集計（メディアシグナル）',
    collect_endpoint: '/api/collect/hatena',
    phase: 2,
    implemented: true,
  },
  {
    name: 'estat',
    display_name: 'e-Stat 政府統計',
    description: '産業大分類別事業所数（供給シグナル）。JSIC大分類粒度のため一部業種は同値。設定画面で ESTAT_APP_ID を投入後に有効',
    collect_endpoint: '/api/collect/estat',
    phase: 2,
    implemented: true,
  },
  {
    name: 'youtube',
    display_name: 'YouTube Data API',
    description: 'カテゴリ別検索ボリューム（需要シグナル）。設定画面で YOUTUBE_API_KEY を投入後に有効',
    collect_endpoint: '/api/collect/youtube',
    phase: 2,
    implemented: true,
  },
  {
    name: 'trends',
    display_name: 'Google Trends',
    description: '外部VPSから POST 受け口経由（管理UIから直接実行不可）',
    collect_endpoint: null,
    phase: 2,
    implemented: false,
    pending_reason: '外部VPSからの POST 受け口（/api/ingest/trends）',
  },
];
